import { useFormContext } from 'react-hook-form';
import { ISelectCardFormData } from '../types/ISelectCardFormData';

export const useSelectCardFormContext = () =>
	useFormContext<ISelectCardFormData>();
